import { render, staticRenderFns } from "./selectorView.vue?vue&type=template&id=a3c3378a&scoped=true&"
import script from "./selectorView.vue?vue&type=script&lang=js&"
export * from "./selectorView.vue?vue&type=script&lang=js&"
import style0 from "./selectorView.vue?vue&type=style&index=0&id=a3c3378a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3378a",
  null
  
)

export default component.exports